export function resolveUseSamePath(currentFieldPath, fieldNameToResolve) {
    var fieldNamePath = currentFieldPath.split('.');
    if (fieldNamePath.length > 1) {
        fieldNamePath[fieldNamePath.length - 1] = fieldNameToResolve;
        return fieldNamePath.join('.');
    }
    return fieldNameToResolve;
}
